import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getProductCategoryList(actions) {

  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query !== undefined
        ? apiUrl + "/opa-product-categories" + actions.query + "&include=images"
        : actions.page !== undefined
          ? apiUrl +
          "/opa-product-categories?page=" +
          actions.page +
          "&include=images"
          : apiUrl + "/opa-product-categories?page_size=1000&include=images";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);


    yield put({ type: "LIST_PRODUCT_CATEGORY_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_PRODUCT_CATEGORY_RESPONSE_GET", value: error });
  }
}

function* getProductCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-product-category/"
        : `${apiUrl}/opa-product-category/${actions.query}?include=images,products`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response) {
        responseStatus = "success";
      } else {
        responseStatus = response;
      }
    }

    yield put({ type: "PRODUCT_CATEGORY_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "PRODUCT_CATEGORY_RESPONSE_GET", value: error });
  }
}

function* editProductCategory(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-product-category/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }
    const response = yield call(apiCall, "PATCH", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_CATEGORY_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "PRODUCT_CATEGORY_RESPONSE_EDIT",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* addProductCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-category";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_CATEGORY_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "PRODUCT_CATEGORY_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* deleteProductCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };


    let url = apiUrl + "/opa-product-category/" + actions.productCategoryUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "delete", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_CATEGORY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "PRODUCT_CATEGORY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

export function* getSagaProductCategoryList() {
  yield takeEvery("GET_LIST_PRODUCT_CATEGORY", getProductCategoryList);
}

export function* getSagaProductCategory() {
  yield takeEvery("GET_PRODUCT_CATEGORY", getProductCategory);
}

export function* addSagaProductCategory() {
  yield takeEvery("ADD_PRODUCT_CATEGORY", addProductCategory);
}

export function* deleteSagaProductCategory() {
  yield takeEvery("DELETE_PRODUCT_CATEGORY", deleteProductCategory);
}

export function* editSagaProductCategory() {
  yield takeEvery("EDIT_PRODUCT_CATEGORY", editProductCategory);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
